import { ColorPickerConfig } from 'editor/src/store/hostSettings/types';
import { RootState } from 'editor/src/store/index';

import getSpreadColorPickerConfig from './getSpreadColorPickerConfig';

const getCurrentSpreadColorPickerConfig = (state: RootState): ColorPickerConfig =>
  getSpreadColorPickerConfig(state, state.editor.currentSpreadIndex);

export default getCurrentSpreadColorPickerConfig;
